import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './lib/auth.tsx'
import Layout from './components/Layout.tsx'
import Login from './pages/Login.tsx'
import Register from './pages/Register.tsx'
import Notes from './pages/Notes.tsx'
import NoteEditor from './pages/NoteEditor.tsx'
import SystemDashboard from './pages/SystemDashboard.tsx'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }
  
  if (!user) {
    // Store the intended URL to redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  return <>{children}</>
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }
  
  return !user ? <>{children}</> : <Navigate to="/notes" replace />
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Public routes */}
        <Route 
          path="login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path="register" 
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          } 
        />
        
        {/* Private routes */}
        <Route 
          path="notes" 
          element={
            <PrivateRoute>
              <Notes />
            </PrivateRoute>
          } 
        />
        <Route 
          path="notes/new" 
          element={
            <PrivateRoute>
              <NoteEditor />
            </PrivateRoute>
          } 
        />
        <Route 
          path="notes/:id" 
          element={
            <PrivateRoute>
              <NoteEditor />
            </PrivateRoute>
          } 
        />
        
        {/* System Dashboard - Public */}
        <Route 
          path="system" 
          element={<SystemDashboard />} 
        />
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/notes" replace />} />
      </Route>
    </Routes>
  )
}

export default App
